document.addEventListener("DOMContentLoaded", function () {
  const wishlistButtons = document.querySelectorAll(
    ".xo-header-v8__right-item--heart, .xo-wishlist-btn"
  );

  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  }

  function saveWishlist(list) {
    localStorage.setItem("wishlist", JSON.stringify(list));
  }

  function toggleWishlist(productId) {
    let wishlist = getWishlist();
    if (wishlist.includes(productId)) {
      wishlist = wishlist.filter((id) => id !== productId);
    } else {
      wishlist.push(productId);
    }
    saveWishlist(wishlist);
    updateWishlistCount();
  }

  function updateWishlistCount() {
    const countEl = document.querySelector(".wishlist-count");
    if (countEl) {
      countEl.textContent = getWishlist().length;
    }
  }

  wishlistButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const productId = this.getAttribute("data-product-id");
      if (!productId) {
        console.warn("Wishlist button missing data-product-id");
        return;
      }
      toggleWishlist(productId);
    });
  });

  updateWishlistCount();
});